import { useTranslation } from "react-i18next"
import { DateTime } from "luxon"
import classNames from "classnames"
import { twMerge } from "tailwind-merge"
import { Invoice } from "@oysterhr/schema"
import { getClientInvoiceDueDate } from "../utils/getClientInvoiceDueDate"

interface Props {
  invoice: Pick<Invoice, "state" | "subkind" | "dueDate">
  className?: string
  onValid?: (date: DateTime) => JSX.Element
}

export const InvoiceDueDateValue = ({ invoice, className, onValid }: Props): JSX.Element => {
  const { t } = useTranslation("Invoices")
  const dueDate = getClientInvoiceDueDate(invoice, t)

  if (!dueDate) return <span>-</span>

  const date = dueDate ? DateTime.fromISO(dueDate) : null
  if (date?.isValid) {
    if (onValid) {
      return onValid(date)
    }
    return <span className={className}>{date.toLocaleString(DateTime.DATE_MED)}</span>
  }

  return (
    <span className={twMerge(classNames("whitespace-break-spaces", className))}>{dueDate}</span>
  )
}
